
    <template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 15">
  <path
    d="M7.89199 0L8.9472 1.04475L2.66863 7.36639L9 13.6348L7.95371 14.6882L0.567262 7.37499L7.89199 0Z"
    fill="currentColor"
  ></path>
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ArrowLeft',
    }) as DefineComponent
    </script>
    